module.exports = __webpack_public_path__ + "img/main.64e6b20e.png";